export function trace(str, ...args) {
    if (v24Scheduler.traceEnabled) {
      str = "Vee24 - " + str;
      if (args && args.length > 0) {
        console.log(str, args);
      }
      else {
        console.log(str);
      }
  
    }
  }